<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.00049 15.9995C5.00049 9.92451 9.92525 4.99976 16.0002 4.99976C22.0752 4.99976 27 9.92452 27 15.9995C27 22.0745 22.0752 26.9993 16.0002 26.9993C9.92525 26.9993 5.00049 22.0745 5.00049 15.9995ZM15.4369 20.3609L21.8657 13.6681L20.2049 12.0769L14.6065 17.903L11.9486 15.0963L10.2879 16.6875L13.7761 20.3609C13.9931 20.5873 14.293 20.7153 14.6065 20.7153C14.92 20.7153 15.22 20.5873 15.4369 20.3609Z"
        />
    </svg>
</template>
